var _a, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "esnjhoDV8OL1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1286.66 380",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/Lanny-MacMillan"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-248.847705-520.030314)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.036858 13.916873)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.000001 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.656612,
    height: 7.95475,
    rx: 0,
    ry: 0,
    transform: "matrix(1.974075 0 0 1 850.000024 878.067875)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.980604,882.0452L879.35311,830h41.29379L930,882.0452h-60.019396Z",
    fill: "#141c3a",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    rx: 10,
    ry: 10,
    transform: "matrix(1 0 0 1.3 700 570)",
    fill: "#141c3a",
    stroke: "#141c3a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    rx: 0,
    ry: 0,
    transform: "matrix(.963614-.000333 0.000325 0.938049 707.23505 576.261803)",
    fill: "#4fecec",
    stroke: "#141c3a",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10,
    ry: 10,
    transform: "translate(900 800)",
    fill: "#d2dbed",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    dx: 0,
    dy: 0,
    fontFamily: "\"esnjhoDV8OL1:::Concert One\"",
    fontSize: 20,
    fontWeight: 400,
    letterSpacing: 1,
    transform: "translate(715.354356 600.061675)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontWeight: 400,
    strokeWidth: 0
  }, "\nLanny.dev\n")), /*#__PURE__*/React.createElement("rect", {
    id: "esnjhoDV8OL32",
    width: 10,
    height: 17,
    rx: 0,
    ry: 0,
    transform: "translate(809.396444 584.499372)",
    fill: "#c2c5ca",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-987.373261-1.745082)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 100,
    rx: 6,
    ry: 6,
    transform: "matrix(1 0 0 1.2 1500 780)",
    fill: "#141c3a",
    stroke: "#141c3a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4,
    ry: 4,
    transform: "translate(1530 887.435741)",
    fill: "#d2dbed",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 88.020403,
    rx: 0,
    ry: 0,
    transform: "translate(1500 790.000001)",
    fill: "#4fecec",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.264899-.740051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 311.763406,
    rx: 5,
    ry: 5,
    transform: "translate(1223.036858 584.202573)",
    fill: "#109494",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.036858 0.000001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304.424696,
    height: 13,
    rx: 0,
    ry: 0,
    transform: "matrix(.629033 0 0 0.941275 1124.116254 588.361758)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.5,
    transform: "translate(1150.340545 594.480046)",
    fill: "#00ff2d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.5,
    transform: "translate(1140.380119 594.480045)",
    fill: "#daff05",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.500003,
    transform: "matrix(1 0 0 0.999999 1131.374631 594.480045)",
    fill: "#f50517",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(785.103119 328.845652)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 65,
    ry: 65,
    transform: "translate(425 505)",
    fill: "#4fecec",
    stroke: "#141c3a",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -13.756622,
    y1: 5.851698,
    x2: 13.756622,
    y2: -5.851697,
    transform: "matrix(1.199949-.011044 0.011044 1.199949 461.705469 513.496601)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -13.859283,
    y1: -5.749036,
    x2: 13.859283,
    y2: 5.749036,
    transform: "matrix(1.199833-.02002 0.02002 1.199833 461.520744 498.528965)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.319363,
    y1: -5.543714,
    x2: -12.319363,
    y2: 5.543714,
    transform: "matrix(1.2 0 0 1.2 387.297883 499.350255)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.060813,
    y1: 25.973323,
    x2: 10.060813,
    y2: -25.973323,
    transform: "matrix(1.2 0 0 1.2 423.680384 505.899822)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.319363,
    y1: 5.954358,
    x2: -12.319363,
    y2: -5.954359,
    transform: "matrix(1.1996-.030991 0.030991 1.1996 387.379946 513.804584)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-588.460744 3.044316)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    rx: 5,
    ry: 5,
    transform: "matrix(.637197 0 0 0.680679 1185.1212 741.9321)",
    fill: "#b2e6e2",
    stroke: "#141c3a",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.060638c0-.552285,6.981727-5.060649,7.534012-5.060649l263,.000011C271.086297,0,280,4.618145,280,4.618145v1.689755c0,.552285,0,1.6469-2.465988,1.6469h-274.094602C0,7.9548,0,6.860185,0,6.3079v-1.247262Z",
    transform: "matrix(1 0 0 2.367206 1173.465988 878.020428)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0h40l7.439318,8.957833h-55.303587L0,0Z",
    transform: "matrix(1.000003 0 0 0.994362 1292.773017 881.568961)",
    fill: "#d2dbed",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(585.717485 162.014978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 140,
    rx: 5,
    ry: 5,
    transform: "translate(500 370)",
    fill: "#b2e6e2",
    stroke: "#141c3a",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 13.516723,
    rx: 0,
    ry: 0,
    transform: "translate(500 370.000001)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.5,
    transform: "translate(508.375006 376.758363)",
    fill: "#f50517",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.5,
    transform: "translate(517.375006 376.758363)",
    fill: "#daff05",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.5,
    ry: 2.5,
    transform: "translate(526.939605 376.758363)",
    fill: "#00ff2d",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-486.476634-162.913105)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.848796,
    height: 94.696601,
    rx: 0,
    ry: 0,
    transform: "translate(994.548539 558.874042)",
    fill: "#109494",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.925602,
    y1: -0.028728,
    x2: -48.424398,
    y2: 0.391272,
    transform: "translate(1042.245643 653.725957)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 48.99155,
    x2: 0,
    y2: -48.991551,
    transform: "matrix(1 0 0 0.958515 993.490266 607.160052)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "esnjhoDV8OL93",
    d: "M0,0c55.133575,100.21631,65.133575-97.175511,96.53091,0c0,0-.081653,54.913866-.081653,54.913866L0,54.965633Q0,5.496563,0,0Z",
    transform: "translate(994 598.60501)",
    fill: "#4fecec",
    stroke: "#3f5787",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "esnjhoDV8OL94"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 38.74843,
    ry: 38.74843,
    transform: "translate(660.80325 444.483768)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.723564,
    height: 10.80396,
    rx: 4.86,
    ry: 4.86,
    transform: "translate(656.052891 400.64996)",
    fill: "#ff7fff",
    stroke: "#3f5787"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.723564,
    height: 10.80396,
    rx: 4.86,
    ry: 4.86,
    transform: "translate(656.052891 477.512029)",
    fill: "#7fff7f",
    stroke: "#3f5787"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.723564,
    height: 10.80396,
    rx: 4.86,
    ry: 4.86,
    transform: "translate(694.472257 439.17145)",
    fill: "#4fecec",
    stroke: "#3f5787",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.723564,
    height: 10.80396,
    rx: 4.86,
    ry: 4.86,
    transform: "translate(617.250706 439.17145)",
    fill: "#ffff40",
    stroke: "#3f5787",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.833065 0 0 0.485008-1536.3393 382.120322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 311.763406,
    rx: 5,
    ry: 5,
    transform: "matrix(.381874 0 0 1.202953 1238.022776 552.258181)",
    fill: "#13b9b9",
    stroke: "#141c3a",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.000022-.000004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.561344,
    height: 26.803682,
    rx: 0,
    ry: 0,
    transform: "matrix(.341628 0 0 1 1238.022732 552.565913)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.363836,
    ry: 5.154554,
    transform: "translate(1250.812701 565.96775)",
    fill: "#00ff2d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.363836,
    ry: 5.154554,
    transform: "translate(1246.41862 565.967751)",
    fill: "#daff05",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.363836,
    ry: 5.154559,
    transform: "matrix(1 0 0 0.999999 1241.744707 565.96775)",
    fill: "#f50517",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.210147 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -70.299995,
    x2: 0,
    y2: 68.532462,
    transform: "matrix(-1 0 0 1.925317 1186.323547 744.110346)",
    fill: "none",
    stroke: "#ffff40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -58.731775,
    x2: 0,
    y2: 55.162797,
    transform: "matrix(-1 0 0 1.970265 1191.254353 744.691698)",
    fill: "none",
    stroke: "#7fff7f"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -46.692107,
    x2: 0,
    y2: 46.692107,
    transform: "matrix(-1 0 0 1.970265 1195.868821 742.029432)",
    fill: "none",
    stroke: "#ff7fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -46.692107,
    x2: 0,
    y2: 46.692107,
    transform: "matrix(-1 0 0 1.525457 1200.106609 744.691697)",
    fill: "none",
    stroke: "#4fecec"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.291614-.000054)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL113",
    x1: -48.600281,
    y1: 0,
    x2: 53.075331,
    y2: 0,
    transform: "matrix(.595037 0 0-1.970265 1216.225232 597.711134)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 101.68,
    strokeDasharray: 101.68
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL114",
    x1: -48.600281,
    y1: 0,
    x2: 53.075331,
    y2: 0,
    transform: "matrix(.505027 0 0-1.970265 1217.676488 618.090406)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 101.68,
    strokeDasharray: 101.68
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL115",
    x1: -55.794284,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.509219 0 0 1.970265 1223.626176 639.350654)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 104.4,
    strokeDasharray: 104.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL116",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.488021 0 0 1.970265 1223.95676 659.565784)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL117",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.49272 0 0 1.970265 1227.484149 680.184001)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL118",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.487427 0 0-1.970265 1227.573551 700.802216)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL119",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.490035 0 0 1.970265 1227.573551 721.420433)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL120",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.429617 0 0-1.970265 1224.781236 743.339837)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL121",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.490035 0 0 1.970265 1227.874894 764.428015)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL122",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.490035 0 0 1.970265 1227.79348 785.084529)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL123",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.490035 0 0 1.970265 1227.630656 805.741044)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL124",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.540757 0 0 1.970265 1225.943602 825.147947)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL125",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.58766 0 0 1.970265 1223.83948 845.027332)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL126",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.51136 0 0 1.970265 1215.58135 863.754045)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL127",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.642675 0 0 1.970265 1216.888887 885.341776)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "esnjhoDV8OL128",
    x1: -48.600281,
    y1: 0,
    x2: 48.600282,
    y2: 0,
    transform: "matrix(.190224 0 0-1.970265 1194.856182 905.877535)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3,
    strokeDashoffset: 97.21,
    strokeDasharray: 97.21
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-99.067288 0.362092)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 22.5,
    ry: 22.5,
    transform: "translate(1595.23213 849.4321)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.501712,
    height: 102.670339,
    rx: 10,
    ry: 10,
    transform: "matrix(1 0 0 0.789063 1537.853846 818.930034)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.501712,
    height: 21.974791,
    rx: 0,
    ry: 0,
    transform: "translate(1537.853846 804.957309)",
    fill: "#141c3a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.445143 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "esnjhoDV8OL134",
    d: "M0,32.000014C-20,8.000011,17.31947,-5.599495,0,-32.000015",
    transform: "matrix(1 0 0 0.82 1349.133059 777.847321)",
    opacity: 0.62,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeDashoffset: 68.49,
    strokeDasharray: 68.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "esnjhoDV8OL135",
    d: "M-2.396044,6.621936c-12.069801-14.483227,10.452128-22.690089,0-38.621951",
    transform: "matrix(1 0 0 0.82 1369.869819 795.031688)",
    opacity: 0.62,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeDashoffset: 68.49,
    strokeDasharray: 68.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "esnjhoDV8OL136",
    d: "M0,32.000014C-20,8.000011,17.31947,-5.599495,0,-32.000015",
    transform: "matrix(1 0 0 0.82 1388.12542 774.221665)",
    opacity: 0.62,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeDashoffset: 68.49,
    strokeDasharray: 68.49
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-2.460713)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1109.266996 0.000004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.118172 0 0 1-186.964779 0.308182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.844404,0.822055c5.012132-1.601859,57.103902.137114,104.183541.411012-12.29459,5.275779-13.837447,16.745254-3.202361,24.866314-43.436641.504709-93.154328,5.273668-103.116088-.205507-2.776795-6.39787-4.827658-17.669907,2.134908-25.071819Z",
    transform: "matrix(.967197 0 0 1.07519 1490.299066 864.389414)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.34665,
    y1: 0,
    x2: -45.34665,
    y2: 0,
    transform: "matrix(.803583 0 0-1 1548.998961 885.07354)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.34665,
    y1: 0,
    x2: -45.34665,
    y2: 0,
    transform: "matrix(.803583 0 0-1 1548.998961 873.626479)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -50,
    y1: 0,
    x2: 50,
    y2: 0,
    transform: "translate(1550 897.5)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: -50,
    y1: 0,
    x2: 50,
    y2: 0,
    transform: "translate(1550 861.439285)",
    fill: "#141c3a",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,879.966392q.376834-18.527107,20.10445-18.527107",
    transform: "translate(.871909 0)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,875.25927q.281157-13.819989,15-13.819989",
    transform: "matrix(1.000004 0 0 1 105.09847 4.977356)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,879.966392q.376834-18.527107,20.10445-18.527107",
    transform: "matrix(1 0 0-1 0.871909 1758.93927)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,875.25927q.281157-13.819989,15-13.819989",
    transform: "matrix(1.000004 0 0-1 105.09847 1754.955429)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.913258 0.407381-.407381-.913258 2093.193856 1031.862866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.844404,0.822055c5.012132-1.601859,57.103902.137114,104.183541.411012-12.29459,5.275779-13.837447,16.745254-3.202361,24.866314-43.436641.504709-93.154328,5.273668-103.116088-.205507-2.776795-6.39787-4.827658-17.669907,2.134908-25.071819Z",
    transform: "matrix(1.03498 0 0 1.07519 1484.044715 864.704832)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.118172 0 0 1-186.964779 0.308182)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 45.34665,
    y1: 0,
    x2: -45.34665,
    y2: 0,
    transform: "matrix(.803583 0 0-1 1548.998961 885.07354)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.34665,
    y1: 0,
    x2: -45.34665,
    y2: 0,
    transform: "matrix(.803583 0 0-1 1548.998961 873.626479)",
    fill: "none",
    stroke: "#3f5787",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: -50,
    y1: 0,
    x2: 50,
    y2: 0,
    transform: "translate(1550 897.5)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: -50,
    y1: 0,
    x2: 50,
    y2: 0,
    transform: "translate(1550 861.439285)",
    fill: "#141c3a",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,879.966392q.376834-18.527107,20.10445-18.527107",
    transform: "translate(1.461764 0.012582)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,875.25927q.281157-13.819989,15-13.819989",
    transform: "matrix(1.000004 0 0 1 105.09847 4.977356)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,879.966392q.376834-18.527107,20.10445-18.527107",
    transform: "matrix(1 0 0-1 1.461764 1758.951852)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.89555,875.25927q.281157-13.819989,15-13.819989",
    transform: "matrix(1.000004 0 0-1 105.09847 1754.955429)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.890029 396.799358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.702963,1.485472c0-8.060956,12.44827-18.248405,25.591134-18.248405s27.573565,11.852661,26.071724,19.069876-12.988931,5.222212-26.131795,5.222212-25.531063,2.017273-25.531063-6.043683Z",
    transform: "matrix(.976753 0 0 1 564.707455 494.481037)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.526301,0c0-29.951251,49.843612-29.951251,49.843612-.096174",
    transform: "translate(566.607988 499.951251)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -24.921806,
    y1: 0,
    x2: 24.921806,
    y2: 0,
    transform: "matrix(1.098798 0 0-1 565.003493 500.743017)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -4.468388,
    x2: 0,
    y2: 4.468388,
    transform: "translate(564.784681 482.682098)",
    fill: "none",
    stroke: "#141c3a",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9 0 0 0.9 145.655729 404.14897)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 26.449533,
    ry: 26.449533,
    transform: "translate(441.478739 480.96173)",
    fill: "#141c3a",
    stroke: "#13b9b9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.681008,-14.996162c-.41126,3.642569-7.201025,18.73243-12.222506,31.066079c5.78473-25.280145,7.079184-38.387421,12.222506-31.066079Z",
    transform: "matrix(-.978692 0.205333 0.205333 0.978692 450.262167 479.589652)",
    fill: "none",
    stroke: "#13b9b9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.681008,-14.996162L-4.541498,16.069917c5.78473-25.280145,7.079184-38.387421,12.222506-31.066079Z",
    transform: "matrix(.978248 0.207439-.207439 0.978248 433.21156 479.650218)",
    fill: "none",
    stroke: "#13b9b9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.681008,-14.996162c-.86622,4.385047-7.556074,19.817841-12.222506,31.066079c5.78473-25.280145,7.079184-38.387421,12.222506-31.066079Z",
    transform: "matrix(.978248 0.207439-.207439 0.978248 433.21156 479.650218)",
    fill: "none",
    stroke: "#3cbbb1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@font-face {font-family: 'esnjhoDV8OL1:::Concert One';font-style: normal;font-weight: 400;src: url(data:font/ttf;charset=utf-8;base64,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) format('truetype');}@font-face {font-family: 'esnjhoDV8OL1:::Roboto';font-style: normal;font-weight: 400;src: url(data:font/ttf;charset=utf-8;base64,AAEAAAASAQAABAAgR0RFRgAVABEAAAE4AAAAFkdQT1MFZe5bAAAFMAAAAUpHU1VCkw2CAgAAAfgAAAA0T1MvMnSaAagAAAMAAAAAYGNtYXACHAMYAAADYAAAAIRjdnQgK6gHnQAAAqwAAABUZnBnbXf4YKsAAAfwAAABvGdhc3AACAATAAABLAAAAAxnbHlmvZNz5AAACawAAAlGaGRteBoZFCkAAAFQAAAAHGhlYWT8atJ6AAACLAAAADZoaGVhCroFsgAAAawAAAAkaG10eENYBlsAAAJkAAAASGxvY2EWtxTKAAAB0AAAACZtYXhwAkIDCQAAAWwAAAAgbmFtZRudOGoAAAZ8AAABdHBvc3T/bQBkAAABjAAAACBwcmVwomb6yQAAA+QAAAFJAAEAAgAIAAL//wAPAAEAAAAMAAAAAAAAAAIAAQAFABAAAQAAAAAAAQAAABQJCAQCAwMCBQUFBQgFBQUDBAQEAgABAAAAEgCPABYAVAAFAAEAAAAAAA4AAAIAAiQABgABAAMAAAAAAAD/agBkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAB2z+DAAACUn6G/5KCTAAAQAAAAAAAAAAAAAAAAAAABIAAABhAGEAiwC1ANcA+wF1AdQCPQKpAvQDQwOoA+YEFgRdBKMEowAAAAEAAAAKADIAMgAEREZMVAAeY3lybAAaZ3JlawAabGF0bgAaAAAAAAAEAAAAAP//AAAAAAABAAAAAiMSbpM1Ol8PPPUAGQgAAAAAAMTwES4AAAAA1QFS9Pob/dUJMAhzAAAACQACAAAAAAAAA4wAZAH7AAACvACFAsgAJgIbAJAETgCpBFoAbQSDAF8EPQBdBwMAiwRqAIwEkABbBH0AjAK1AIwD4AAhA/cAKQPJABYB+wAAACoAnQCAAIoAeADUAGQATgBaAIcAYABWADQCPAC8ALIAjgDEAAAAFP5gABQCmwAgAyEACwQ6ABQEjQAQBbAAFAYYABUBpgARBsAADgbZAAYAAAAAAAMEhgGQAAUAAAWaBTMAAAEfBZoFMwAAA9EAZgIAAAACAAAAAAAAAAAAgAAAJwAAAEsAAAAgAAAAAEdPT0cAQAAA//0GAP4AAGYHmgIAIAABnwAAAAAEOgWwACAAIAADAAAAAgAAAAMAAAAUAAMAAQAAABQABABwAAAAGAAQAAMACAAgACkALgBMAGEAZQBwAHIAdgB5AKD//wAAACAAKAAuAEwAYQBkAG0AcgB2AHgAoP///+H/2v/W/7n/pf+j/5z/m/+Y/5f/cQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsAwrsAArALIBEAIrAbIRAQIrAbcROjAlGxAACCsAtwFIOy4hFAAIK7cCWEg4KBQACCu3A1JDNCUWAAgrtwReTTwrGQAIK7cFNiwiGQ8ACCu3BnFdRjIbAAgrtweRd1w6IwAIK7cIfmdQORoACCu3CVRFNiYUAAgrtwp2YEs2HQAIK7cLg2ROOiMACCu3DNmyimM8AAgrtw0UEAwJBgAIK7cOPDInHBEACCu3D0A0KR0UAAgrtxBQQS4hFAAIKwCyEgsHK7AAIEV9aRhEsj8aAXOyXxoBc7J/GgFzsi8aAXSyTxoBdLJvGgF0so8aAXSyrxoBdLL/GgF0sh8aAXWyPxoBdbJfGgF1sn8aAXWyDx4Bc7J/HgFzsu8eAXOyHx4BdLJfHgF0so8eAXSyzx4BdLL/HgF0sj8eAXWybx4BdbIvIAFzsm8gAXMAAAAAAQAAAAoAMAA+AARERkxUABpjeXJsABpncmVrABpsYXRuABoABAAAAAD//wABAAAAAWtlcm4ACAAAAAEAAAABAAQAAgAAAAEACAACALAABAAAAOAAwAAKAAgAAAAAAAAAAAAA//H/6wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/8QAAAAAAAAAAAAAAAAAA//X/8QAAAAAAAAAAAAAAAP/zAAAAAAAA//MAAP/x//EAAAAA/5UAAP/sAAD/7AAAAAAAAAAAAAD/7QAA/+z/2AASAAD/hQAAAAAAAAAAAAD/ewAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAgAEAAYAAAAIABAAAwABAAQADQAHAAAABAABAAEAAgACAAMAAgAAAAUABgAFAAEABAANAAkACAACAAAABAABAAEAAAADAAcABQAGAAUAAAAAAAgAZgADAAEECQAAAF4AsAADAAEECQABAAwApAADAAEECQACAA4AlgADAAEECQADAAwApAADAAEECQAEAAwApAADAAEECQAFACYAcAADAAEECQAGABwAVAADAAEECQAOAFQAAABoAHQAdABwADoALwAvAHcAdwB3AC4AYQBwAGEAYwBoAGUALgBvAHIAZwAvAGwAaQBjAGUAbgBzAGUAcwAvAEwASQBDAEUATgBTAEUALQAyAC4AMABSAG8AYgBvAHQAbwAtAFIAZQBnAHUAbABhAHIAVgBlAHIAcwBpAG8AbgAgADIALgAxADMANwA7ACAAMgAwADEANwBSAGUAZwB1AGwAYQByAFIAbwBiAG8AdABvAEMAbwBwAHkAcgBpAGcAaAB0ACAAMgAwADEAMQAgAEcAbwBvAGcAbABlACAASQBuAGMALgAgAEEAbABsACAAUgBpAGcAaAB0AHMAIABSAGUAcwBlAHIAdgBlAGQALrAALEuwCVBYsQEBjlm4Af+FsIQdsQkDX14tsAEsICBFaUSwAWAtsAIssAEqIS2wAywgRrADJUZSWCNZIIogiklkiiBGIGhhZLAEJUYgaGFkUlgjZYpZLyCwAFNYaSCwAFRYIbBAWRtpILAAVFghsEBlWVk6LbAELCBGsAQlRlJYI4pZIEYgamFksAQlRiBqYWRSWCOKWS/9LbAFLEsgsAMmUFhRWLCARBuwQERZGyEhIEWwwFBYsMBEGyFZWS2wBiwgIEVpRLABYCAgRX1pGESwAWAtsAcssAYqLbAILEsgsAMmU1iwQBuwAFmKiiCwAyZTWCMhsICKihuKI1kgsAMmU1gjIbDAioobiiNZILADJlNYIyG4AQCKihuKI1kgsAMmU1gjIbgBQIqKG4ojWSCwAyZTWLADJUW4AYBQWCMhuAGAIyEbsAMlRSMhIyFZGyFZRC2wCSxLU1hFRBshIVktsAossChFLbALLLApRS2wDCyxJwGIIIpTWLlAAAQAY7gIAIhUWLkAKAPocFkbsCNTWLAgiLgQAFRYuQAoA+hwWVlZLbANLLBAiLggAFpYsSkARBu5ACkD6ERZLQAFAGQAAAMoBbAAAwAGAAkADAAPAHGyDBARERI5sAwQsADQsAwQsAbQsAwQsAnQsAwQsA3QALAARViwAi8bsQIePlmwAEVYsAAvG7EAEj5ZsgQCABESObIFAgAREjmyBwIAERI5sggCABESObEKDPSyDAIAERI5sg0CABESObACELEODPQwMSEhESEDEQEBEQEDIQE1ASEDKP08AsQ2/u7+ugEM5AID/v4BAv39BbD6pAUH/X0Cd/sRAnj9XgJeiAJeAAEAhf4qApUGawARAAkAsA4vsAQvMDETNBISNxcGAgMHEBMWFwcmJwKFefCBJpK7CQGNVXUmhXnsAk/iAaABVEZ6cP40/uNV/n7+5KpgcUquAVQAAAEAJv4qAjcGawARAAkAsA4vsAQvMDEBFAICByc2EhM1NAICJzcWEhICN3XxhCeauwJYnWInhO93AkXf/mf+pklxdgHxAS8g0gFpAR5QcUn+qv5kAAEAkP/1AXYA0QAJABwAsABFWLAHLxuxBxI+WbECBbAKK1gh2Bv0WTAxNzQ2MhYVFAYiJpA5cjs7cjlhMEBAMC4+PgAAAQCpAAAEHAWwAAUAKQCwAEVYsAQvG7EEHj5ZsABFWLACLxuxAhI+WbEAAbAKK1gh2Bv0WTAxJSEVIREzAWoCsvyNwZ2dBbAAAgBt/+wD6gROAB4AKAB8shcpKhESObAXELAg0ACwAEVYsBcvG7EXGj5ZsABFWLAELxuxBBI+WbAARViwAC8bsQASPlmyAhcEERI5sgsXBBESObALL7AXELEPAbAKK1gh2Bv0WbISCxcREjmwBBCxHwGwCitYIdgb9FmwCxCxIwGwCitYIdgb9FkwMSEmJwYjIiY1NCQzMzU0JiMiBhUjNDY2MzIWFxEUFxUlMjY3NSMgFRQWAygQCoGzoM0BAem0dHFjhrpzxXa71AQm/gtXnCOR/qx0IFKGtYupu1Vhc2RHUZdYu6T+DpVYEI1aSN7HV2IAAAIAX//sA/AGAAAPABoAZrIYGxwREjmwGBCwA9AAsAYvsABFWLADLxuxAxo+WbAARViwDC8bsQwSPlmwAEVYsAgvG7EIEj5ZsgUDDBESObIKAwwREjmwDBCxEwGwCitYIdgb9FmwAxCxGAGwCitYIdgb9FkwMRM0EjMyFxEzESMnBiMiAjUXFBYzMjcRJiMiBl/sv75vuaoJb8a87bmYhrBRU6yImAIm+QEvggI0+gB0iAE0+Ae40J4B8ZnSAAACAF3/7APzBE4AFQAdAGyyCB4fERI5sAgQsBbQALAARViwCC8bsQgaPlmwAEVYsAAvG7EAEj5ZshoIABESObAaL7S/Gs8aAl2xDAGwCitYIdgb9FmwABCxEAGwCitYIdgb9FmyEwgAERI5sAgQsRYBsAorWCHYG/RZMDEFIgA1NTQ2NjMyEhEVIRYWMzI2NxcGASIGByE1JiYCTdz+7HvdgdPq/SMEs4piiDNxiP7ZcJgSAh4IiBQBIfIiof2P/ur+/U2gxVBCWNEDyqOTDo2bAAABAIsAAAZ4BE4AHQB4sgQeHxESOQCwAEVYsAMvG7EDGj5ZsABFWLAILxuxCBo+WbAARViwAC8bsQAaPlmwAEVYsAsvG7ELEj5ZsABFWLAULxuxFBI+WbAARViwGy8bsRsSPlmyAQgLERI5sgUICxESObAIELEQAbAKK1gh2Bv0WbAY0DAxARc2MzIXNjYzIBMRIxE0JiMiBgcRIxE0IyIHESMRAToFd8rjUjatdgFkBrlqfWeIC7rntkO5BDp4jK5OYP6H/SsCynRze2j9MgLF7Jv86gQ6AAABAIwAAAPfBE4AEQBUsgsSExESOQCwAEVYsAMvG7EDGj5ZsABFWLAALxuxABo+WbAARViwBi8bsQYSPlmwAEVYsA8vG7EPEj5ZsgEDBhESObADELELAbAKK1gh2Bv0WTAxARc2MyATESMRJiYjIgYHESMRATsGfMgBVwO5AWlvWogmuQQ6iJz+ff01Asx1cGBO/P0EOgACAFv/7AQ0BE4ADwAbAEWyDBwdERI5sAwQsBPQALAARViwBC8bsQQaPlmwAEVYsAwvG7EMEj5ZsRMBsAorWCHYG/RZsAQQsRkBsAorWCHYG/RZMDETNDY2MzIAFRUUBgYjIgA1FxQWMzI2NTQmIyIGW33fj90BEXnhktz+77qnjI2mqYyJqAInn/6K/s7+DZ77jAEy/Am02t3Hst3aAAIAjP5gBB4ETgAPABoAcLITGxwREjmwExCwDNAAsABFWLAMLxuxDBo+WbAARViwCS8bsQkaPlmwAEVYsAYvG7EGFD5ZsABFWLADLxuxAxI+WbIFDAMREjmyCgwDERI5sAwQsRMBsAorWCHYG/RZsAMQsRgBsAorWCHYG/RZMDEBFAIjIicRIxEzFzYzMhIRJzQmIyIHERYzMjYEHuLBxXG5qQlxycPjuZyIqFRTq4WdAhH3/tJ9/fcF2niM/tr++gS31JX9+5TTAAABAIwAAAKXBE4ADQBHsgQODxESOQCwAEVYsAsvG7ELGj5ZsABFWLAILxuxCBo+WbAARViwBS8bsQUSPlmwCxCxAgGwCitYIdgb9FmyCQsFERI5MDEBJiMiBxEjETMXNjMyFwKXKjG2Qbm0A1unNhwDlAeb/QAEOn2RDgAAAQAhAAADugQ6AAYAOLIABwgREjkAsABFWLABLxuxARo+WbAARViwBS8bsQUaPlmwAEVYsAMvG7EDEj5ZsgAFAxESOTAxJQEzASMBMwHxAQy9/nyN/ni9+wM/+8YEOgAAAQApAAADygQ6AAsAUwCwAEVYsAEvG7EBGj5ZsABFWLAKLxuxCho+WbAARViwBC8bsQQSPlmwAEVYsAcvG7EHEj5ZsgAKBBESObIGCgQREjmyAwAGERI5sgkGABESOTAxARMzAQEjAwMjAQEzAffw2P6eAW3W+vrXAW3+ntYCrwGL/en93QGV/msCIwIXAAEAFv5LA7AEOgAPAEqyABARERI5ALAARViwAS8bsQEaPlmwAEVYsA4vG7EOGj5ZsABFWLAFLxuxBRQ+WbIADgUREjmxCQGwCitYIdgb9FmwABCwDdAwMQETMwECIycnNRcyNjc3ATMB7vzG/k1l3CNFMl5pIin+fsoBDwMr+x/+8gMNlgRMZW4ELgAAAA==) format('truetype');}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevDesktop);
export default __webpack_public_path__ + "static/media/devDesktop.bbc641fb115d7ebd91b8b275ad2f093a.svg";
export { ForwardRef as ReactComponent };